<template>
  <section class="wrapper_type_2">
    <SuspendedModal
      :statusInfo="statusInfo"
      :branch="true"
      :industry="false"
    ></SuspendedModal>
    <WarningModal
      :statusInfo="statusInfo"
      :branch="true"
      :industry="false"
    ></WarningModal>
    <b-navbar
      class="horizontal_nav_bar"
      :class="collapseNavbar ? 'opened' : ''"
    >
      <b-navbar-brand
        href="#"
        class="hamburger_container"
        :style="[
          statusInfo.status && statusInfo.status == 1
            ? { marginRight: '50px !important' }
            : null,
        ]"
      >
        <span class="hamburger_span_div" @click="toggleCollapsibleNavBar">
          <div class="span-toggler-bar bar1"></div>
          <div class="span-toggler-bar bar2"></div>
          <div class="span-toggler-bar bar3"></div>
        </span>
      </b-navbar-brand>
      <div
        v-if="group"
        style="margin: 0 auto; margin-left: 100px; margin-right: 50px"
        class="m-hide"
      >
        <p class="text-center display-flex branchName" style="margin-bottom: 0">
          <span class="" style="font-size: 25px">{{
            group ? group.name : ""
          }}</span>
          <star-rating
            class="ml-2"
            v-model="groupRating"
            :show-rating="true"
            :read-only="true"
            :star-size="starSize"
            :fixed-points="2"
            :round-start-rating="false"
          ></star-rating>
        </p>
      </div>

      <div style="margin: 0 auto; margin-right: 10%" class="m-hide"></div>

      <b-collapse id="nav-collapse" is-nav>
        <!-- <h4 class="mr-5">{{group ? group.name : ''}} </h4> -->

        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 1"
          class="payment_due_text"
        >
          <span class="text-black">
            {{ $t("text.cusMasterLayout.subscriptionExpire") }}</span
          ><span class="payment_due_date">{{
            timeSince(new Date(statusInfo.dateDue))
          }}</span
          >{{ $t("text.cusMasterLayout.pleasePay") }}
        </b-nav-item>
        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 2"
          class="payment_due_text"
        >
          {{ $t("text.cusMasterLayout.expired") }}
        </b-nav-item>
        <select
          @change="changeLanguage"
          v-model="usedLang"
          class="w-25 mb-3 mb-md-3 mb-sm-5 mb-lg-0"
        >
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select>
        <!-- <select
          @change="changeLanguage"
          class="mr-3"
          style="width: 280px !important"
        >
          <option disabled value="">
            {{ $t("text.cMasterLayout.selectLanguage") }}
          </option>
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select> -->
        <!--<select @change="changeCountry" style="width: 280px !important">
            <option value="">select country</option>
            <option value="FR">France</option>
            <option value="NG">Nigeria</option>
            <option value="KE">Kenya</option>
          </select> -->

        <b-navbar-nav class="ml-auto">
          <b-nav-item
            href="#"
            class="bell_noti"
            style="position: relative"
            v-if="statusInfo.status && statusInfo.status !== 0"
            @click="showNotification"
          >
            <img src="@/assets/img/notification.svg" width="28" />
          </b-nav-item>

          <b-nav-item href="#">
            <img
              :src="
                group && group.url
                  ? group.url
                  : require('@/assets/img/avatar.svg')
              "
              height="30px"
            />
          </b-nav-item>
          <b-nav-item-dropdown>
            <template v-slot:button-content>
              <b class="user_profile_span"
                ><span>{{ userName }}</span> &#x25bc;</b
              >
            </template>
            <b-dropdown-item href="#"
              ><router-link :to="{ name: 'groupProfile' }">{{
                $t("text.cusMasterLayout.profile")
              }}</router-link></b-dropdown-item
            >
            <b-dropdown-item href="#" @click="signOutUser">{{
              $t("text.cusMasterLayout.signOut")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div class="masterLayoutWrapper" :class="collapseNavbar ? 'opened' : ''">
      <section class="main_content">
        <transition name="moveInUp" mode="out-in" appear>
          <div class="slot_div inner_main_content" ref="inner_main_content">
            <slot>
              <router-view />
            </slot>
          </div>
        </transition>
      </section>
    </div>

    <section
      :style="[
        windowLoc == 'interswitchenergy'
          ? { backgroundColor: '#11386a' }
          : windowLoc == 'rainoil'
          ? { backgroundColor: '#0a0044' }
          : windowLoc == 'eterna'
          ? { backgroundColor: '#007236' }
          : windowLoc == 'bovas'
          ? { backgroundColor: '#b28b00' }
          : null,
      ]"
      class="sidebar use-tiny-scroll"
      :class="collapseNavbar ? 'collapsed' : ''"
      @mouseover="toggleSidenavText"
      @mouseleave="hideTitles"
    >
      <div class="mt-3 text-right m-hide-icon">
        <img
          src="@/assets/img/close_btn.png"
          width="35px"
          height="35px"
          @click="toggleCollapsibleNavBar"
          id="mySidenav"
        />
      </div>
      <div class="text-center">
        <div class="company-logo-wrapper">
          <img
            src="@/assets/img/ep-logo.svg"
            class="lg m-hide-icon company-logo"
            width="153"
          />
        </div>

        <div class="mobile-user-details">
          <div class="mt-3 text-right logo_section">
            <img
              src="@/assets/img/close_btn.png"
              width="35px"
              height="35px"
              @click="toggleCollapsibleNavBar"
            />
          </div>
          <div class="mt-3 text-center dasboard_type_button_section">
            <div class="mobile_epump_logo">
              <img src="@/assets/img/mobieli_white_epump_logo.svg" width="20" />
            </div>
            <h6 class="mt-2 text-white">{{ userName }}</h6>
            <small class="mt-2 text-white">{{ userDetails.email }}</small>
          </div>
        </div>
      </div>
      <div class="mt-3 dasboard_type_button_section"></div>

      <div class="mt-4 mb-4 menu-wrapper">
        <ul class="list-group" style="">
          <!-- If youre coming from company dashboard to group dashboard -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'companyDashboard' ? 'navbar_item_active' : ''
            "
            v-if="
              $route.query.groupId &&
              (userDetails.roles.includes('Company') ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'companyDashboard',
                query: { companyId: $route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="text-white fa fa-arrow-left"
                  aria-hidden="true"
                  width="20px"
                ></i
              ></span>
              <span class="sidenav_list_title"
                >{{ $t("text.cusMasterLayout.companyDashboard") }}
              </span>
            </router-link>
          </li>

          <!-- GROUP DASHBOARD -->
          <li
            v-show="!userDetails.roles.includes('GroupBranchList')"
            class="list-group-item"
            :class="
              activeRoute === 'groupDashboard' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'groupDashboard',
                query: this.$route.query.groupId
                  ? {
                      groupId: this.$route.query.groupId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/dashboard (2).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.dashboard") }}
              </span>
            </router-link>
          </li>

          <!-- UPDATE PRICE -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'group_price_management'
                ? 'navbar_item_active'
                : ''
            "
            v-show="
              (userDetails.roles.includes('GroupPrice') &&
                comPlanFeatures.includes('Update Price')) ||
              userDetails.roles.includes('SupportAdmin') ||
              userDetails.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'group_price_management',
                query: this.$route.query.groupId
                  ? {
                      groupId: this.$route.query.groupId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/money-transfer.svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.stationManagement.updatePrice") }}
              </span>
            </router-link>
          </li>

          <!-- PRICE CHANGE LOG -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'group_price_management_log'
                ? 'navbar_item_active'
                : ''
            "
            v-show="userDetails.roles.includes('Price Log')"
          >
            <router-link
              :to="{
                name: 'group_price_management_log',
                query: this.$route.query.groupId
                  ? {
                      groupId: this.$route.query.groupId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/money-transfer.svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.omit.priceChangeLog") }}
              </span>
            </router-link>
          </li>

          <!-- PUMP CALIBRATION -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'group_pump_calibration_logs'
                ? 'navbar_item_active'
                : ''
            "
            v-if="
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <!-- <li
            class="list-group-item"
            :class="
              activeRoute === 'group_pump_calibration_logs'
                ? 'navbar_item_active'
                : ''
            "
            v-if="
              (userInfo.roles.includes('SalesRep') &&
                comPlanFeatures.includes('Pump calibration')) ||
              (userInfo.roles.includes('Company') &&
                comPlanFeatures.includes('Pump calibration')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          > -->
            <router-link
              :to="{
                name: 'group_pump_calibration_logs',
                query: this.$route.query.groupId
                  ? {
                      groupId: this.$route.query.groupId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/measure.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.pumpsCalibration.title") }}
              </span>
            </router-link>
          </li>

          <!-- REPORTS -->
          <li
            v-if="
              (userInfo.roles.includes('CompanyReport') &&
                comPlanFeatures.includes('Report')) ||
              (userInfo.roles.includes('Company') &&
                comPlanFeatures.includes('Report')) ||
              (userInfo.roles.includes('SalesRep') &&
                comPlanFeatures.includes('Report')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
            class="list-group-item treeview"
            :class="
              activeRoute === 'GroupSales' ||
              activeRoute === 'group_branch_sales' ||
              activeRoute === 'group_variance_report' ||
              activeRoute === 'groupTankVariance' ||
              activeRoute === 'BranchSalesTransactions' ||
              activeRoute === 'group_tanks_filled' ||
              activeRoute === 'group_tankstock' ||
              activeRoute === 'group_cashflow' ||
              activeRoute === 'group_products_filled' ||
              activeRoute === 'group-product-valuation' ||
              activeRoute === 'group_wallet' ||
              activeRoute === 'DailyGroupBranchTrans'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/profit-report (1).svg" width="20" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.reports") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'GroupSales',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'GroupSales' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.branchSales") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'group_variance_report',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group_variance_report'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.pumpVariance") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'groupTankVariance',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'groupTankVariance'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.tankVariance") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'group_tanks_filled',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group_tanks_filled'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.tanksFilled") }}
                  </router-link>
                </li>

                <li>
                  <router-link
                    :to="{
                      name: 'group_cashflow',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group_cashflow'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.cashFlow") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'group_wallet',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group_wallet' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.omit.remisSales") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'group_tankstock',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group_tankstock'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.tankStock") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'group_branch_sales',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group_branch_sales'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.groupSalesSummary") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'group_products_filled',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group_products_filled'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.products.productDischarged") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'group-product-valuation',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === ' group-product-valuation'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.products.stockValuation") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- RETAIL OUTLET -->
          <li
            class="list-group-item"
            :class="activeRoute === 'groupBranches' ? 'navbar_item_active' : ''"
            v-if="
              (userInfo.roles.includes('ManageOutlet') &&
                comPlanFeatures.includes('Retail Outlets')) ||
              (userInfo.roles.includes('ViewOutlet') &&
                comPlanFeatures.includes('Retail Outlets')) ||
              (userInfo.roles.includes('SalesRep') &&
                comPlanFeatures.includes('Retail Outlets')) ||
              userInfo.roles.includes('GroupBranchList') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'groupBranches',
                query: this.$route.query.groupId
                  ? {
                      groupId: this.$route.query.groupId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/fuel-station (2).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.products.retailOutlets") }}
              </span>
            </router-link>
          </li>

          <!-- MANUAL RECORDS -->
          <li
            class="list-group-item treeview"
            :class="
              activeRoute === 'GroupServices' || activeRoute === 'GroupLease'
                ? 'navbar_item_active'
                : null
            "
            v-show="
              comPlanFeatures.includes('Manual records') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/folder.png" width="30" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.manualRecords") }}
              </span>
              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'GroupServices',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'GroupServices'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.services") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'GroupLease',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'GroupLease' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.branchLease") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- DRY STOCK -->
          <li
            class="list-group-item treeview"
            :class="
              activeRoute === 'non-wet-product-Sales' ||
              activeRoute === 'NonWetProducts' ||
              activeRoute === 'NonWetProductsCategories' ||
              activeRoute === 'GroupNonWetProductSupply' ||
              activeRoute === 'group-non-wet-product-Sales' ||
              activeRoute === 'GroupProductStock'
                ? 'navbar_item_active'
                : null
            "
            v-show="
              (comPlanFeatures.includes('Dry stock') &&
                userInfo.roles.includes('canManageNonWetProducts')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/box.png" width="30" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.dryStock") }}
              </span>
              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'GroupNonWetProductSupply',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'GroupNonWetProductSupply'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.supplies") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'group-non-wet-product-Sales',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.sales") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'GroupProductStock',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_loyalty'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cDashboard.tanK") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- BANK -->
          <li
            class="list-group-item treeview"
            v-if="
              (userInfo.roles.includes('SetupBank') &&
                comPlanFeatures.includes('Bank')) ||
              (userInfo.roles.includes('SalesRep') &&
                comPlanFeatures.includes('Bank')) ||
              (userInfo.roles.includes('ViewBankDeposit') &&
                comPlanFeatures.includes('Bank')) ||
              (userInfo.roles.includes('ManageTerminals') &&
                comPlanFeatures.includes('Bank')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
            :class="
              activeRoute === 'company_accounts' ||
              activeRoute === 'link-company-bank' ||
              activeRoute === 'group-bank-linked-transactions' ||
              activeRoute === 'live-bank-transactions' ||
              activeRoute === 'group_POS' ||
              activeRoute === 'company-pos-terminals' ||
              activeRoute === 'set-recurring-invoice' ||
              activeRoute === 'group-bank-transactions' ||
              activeRoute === 'subscription-transactions'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/wallet (6).svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.bank") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li
                  v-if="
                    userInfo.roles.includes('ViewBankDeposit') ||
                    userInfo.roles.includes('SalesRep') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'group-bank-linked-transactions',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'link-company-bank'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.bankDeposit") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userInfo.roles.includes('ViewBankLog') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SalesRep') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'group-bank-transactions',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'link-company-bank'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.bankTrans") }}
                  </router-link>
                </li>

                <!-- pos terminal report -->

                <!-- <li
                  v-if="
                    userInfo.roles.includes('ViewBankDeposit') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SalesRep') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'group_POS',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group_POS' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.posReport") }}
                  </router-link>
                </li> -->

                <!-- pos terminals -->

                <!-- <li
                  v-if="
                    userInfo.roles.includes('ManageTerminals') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SalesRep') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'group-pos-terminals',
                      query: this.$route.query.groupId
                        ? {
                            groupId: this.$route.query.groupId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group-pos-terminals'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.posTerminals") }} 
                  </router-link>
                </li> -->
              </ul>
            </div>
          </li>

          <!-- MANAGEMENT -->
          <li
            class="list-group-item treeview"
            :class="
              activeRoute === 'group_price_managers'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/briefcase.svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.management") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'group_price_managers',
                      query: {
                        entityType: 'Group',
                        groupId: this.$route.query.groupId,
                        companyId: $route.query.companyId,
                      },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'group_price_managers'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.priceManager.title") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <li
            v-if="
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
            class="list-group-item"
            :class="
              activeRoute === 'supportCompanies' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'supportCompanies',
              }"
              class="vue_router_link"
            >
              <span class="mr-2">
                <img src="@/assets/svg/support.svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.supportAdmin") }}
              </span>
            </router-link>
          </li>
          <!-- partnership logo -->
          <div
            v-if="windowLoc !== 'localhost' && windowLoc !== 'efueling'"
            class="partner_wraper_side_nav mt-2 mb-4"
          >
            <div class="text-center partners_div mt-2 mb-4">
              <div>
                <img
                  src="@/assets/img/fuelmetrics (5).png"
                  class="mr-3"
                  width="100px"
                />
              </div>
              <div class="vl white"></div>
              <div>
                <img
                  :src="[
                    windowLoc == 'interswitchenergy'
                      ? require('@/assets/img/ISW- Logo white.png')
                      : windowLoc == 'rainoil'
                      ? require('@/assets/img/rainoil_1a.jpg')
                      : windowLoc == 'eterna'
                      ? require('@/assets/img/Eterna-logo_1a.jpg')
                      : windowLoc == 'bovas'
                      ? require('@/assets/img/bovas_1a.png')
                      : 'https://epump.com.ng/images/logo2.svg',
                  ]"
                  class="ml-3"
                  width="100px"
                  height="40px"
                />
              </div>
            </div>
          </div>
          <li
            class="list-group-item m-view vue_router_link"
            @click="signOutUser"
          >
            <span class="mr-2"
              ><i
                class="mr-3 fa fa-sign-out"
                style="font-size: 20px; color: white"
              ></i
            ></span>
            <span class="sidenav_list_title"> Logout </span>
          </li>
        </ul>
      </div>
    </section>
  </section>
</template>

<script>
import LogoUrl from "@/assets/img/logo.svg";
import masterbackgroundUrl from "@/assets/img/retain.jpg";
import configObject from "@/config";
import countryProducts from "@/products";
import WarningModal from "@/components/modals/Dashboard/warningModal";
import SuspendedModal from "@/components/modals/Dashboard/suspendedModal";
import StarRating from "vue-star-rating";

export default {
  name: "MasterLayout",
  components: {
    WarningModal,
    SuspendedModal,
    StarRating,
  },
  data() {
    return {
      statusInfo: {},
      LogoUrl,
      isViewOnly: false,
      masterbackgroundUrl,
      group: {},
      companyIcon: null,
      collapseNavbar: true,
      activeRoute: null,
      mobileNav: this.$store.getters.getMobileNavDrawer,
      showStationManagementDropDown: false,
      showOurCorporateCustomersDropDown: false,
      showManageExpensesDropDown: false,
      showReportDropDown: false,
      showPeddlingManagementDropDown: false,
      supportedCompany: null,
      groupRating: 0,
      starSize: 20,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      windowLoc: window.location.hostname.split(".")[0],
      usedLang: this.$store.getters.getLanguage,
      comPlanFeatures: localStorage.getItem("subPlanFeatures")
        ? JSON.parse(localStorage.getItem("subPlanFeatures"))
        : [],
      PriceApproval: JSON.parse(localStorage.getItem("PriceApproval")),
    };
  },
  watch: {
    collapseNavbar(value) {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );
      if (value) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
  },
  computed: {
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
    userName: {
      get() {
        if (localStorage.getItem("userDetails")) {
          return this.userDetails.firstName + "  " + this.userDetails.lastName;
        } else {
          return "Username";
        }
      },
      set(value) {},
    },
  },

  created() {
    if (this.$route.query.companyId) {
      this.companyId = this.$route.query.companyId;
      this.$eventHub.$emit("companyId", this.$route.query.companyId);
    }
    if (
      this.$route.query.groupId &&
      this.$route.query.companyId &&
      (this.userDetails.roles.includes("Company") ||
        this.userDetails.roles.includes("SupportAdmin") ||
        this.userDetails.roles.includes("PartnerAdmin"))
    ) {
      // this.checkStatus();
      const useId = this.$route.query.companyId
        ? this.$route.query.companyId
        : "";
      this.axios
        .get(
          `${configObject.apiBaseUrl}/GroupManagement/Group/${useId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          const companyGroup = response.data.filter(
            (cur) => cur.id === this.$route.query.groupId,
          );
          this.group = companyGroup[0];
          this.$eventHub.$emit("group", this.group);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            return;
          }
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: "Network Error, Please Check Your Internet Connection",
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: "An Error Occured",
              type: "error",
              duration: 5000,
            });
          }
        });
    }
    if (
      (!this.$route.query.groupId && !this.$route.query.companyId) ||
      (this.$route.query.groupId &&
        this.$route.query.companyId &&
        this.userDetails.roles.includes("SalesRep"))
    ) {
      this.getGroup();
    }
  },
  mounted() {
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;

    if (
      this.userDetails.roles.includes("SupportAdmin") ||
      this.userDetails.roles.includes("PartnerAdmin")
    ) {
      this.support = true;
      this.groupId = this.$route.query.groupId;
      let ml = sessionStorage.getItem(this.groupId);
      if (!ml) {
        let allData = localStorage.getItem("companiesList");
        let dt = JSON.parse(allData);
        dt.forEach((my, index) => {
          if (my.id === this.groupId) {
            ml = JSON.stringify(my);
            sessionStorage.setItem(this.groupId, ml);
          }
        });
      }

      this.group = JSON.parse(ml);
      this.$eventHub.$emit("group", this.group);
    }
    this.checkViewOnly();
    $(".treeview > a").on("click", function (e) {
      e.preventDefault();
      var me = $(this);

      if (me.parent("li").hasClass("open")) {
        //close me
        me.parent("li").removeClass("open");
      } else {
        // Open me & close others
        $(".treeview").removeClass("open");
        me.parent("li").addClass("open");
      }
    });
  },
  beforeMount() {
    // TO REROUTE TO OLD DASHBOARD FOR OLD CLIENT ROLES
    // if (
    //   this.$route.name == "groupDashboard" &&
    //   this.userInfo.roles.includes("Old Client")
    // ) {
    //   this.$router.push({
    //     name: "groupDashboard1",
    //     query: {
    //       companyId: this.$route.query.companyId,
    //       branchId: this.$route.query.branchId,
    //       groupId: this.$route.query.groupId,
    //       dealerId: this.$route.query.dealerId,
    //       regionId: this.$route.query.regionId,
    //     },
    //   });
    // }

    this.activeRoute = this.$route.name;
  },
  methods: {
    showNotification() {
      const status = this.statusInfo.status;
      if (
        (status == 1 && !this.userInfo.roles.includes("SupportAdmin")) ||
        userInfo.roles.includes("PartnerAdmin")
      )
        this.showWarningModal();
      if (
        (status == 2 && !this.userInfo.roles.includes("SupportAdmin")) ||
        userInfo.roles.includes("PartnerAdmin")
      )
        this.showSuspendedModal();
    },
    getGroupRating() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/TransactionRating/Group/${
            this.$route.query.groupId
              ? this.$route.query.groupId
              : this.group.id
          }`,
          configObject.authConfig(),
        )
        .then((res) => {
          if (typeof res.data.averageRateValue === "number") {
            this.companyRating = res.data.averageRateValue;
          }
        })
        .catch((e) => {});
    },
    checkStatus() {
      const modalShown = this.$store.getters.getModalShown;
      if (modalShown) {
        this.statusInfo = this.$store.getters.getStatusInfo;
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/status?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.group.companyId
          }`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.statusInfo = response.data;
          if (response.data.status == 1) {
            if (
              !this.userInfo.roles.includes("SupportAdmin") ||
              userInfo.roles.includes("PartnerAdmin")
            ) {
              this.showWarningModal();
              this.$store.commit("setModalShown", true);
            }
          }
          if (response.data.status == 2) {
            if (
              !this.userInfo.roles.includes("SupportAdmin") ||
              userInfo.roles.includes("PartnerAdmin")
            ) {
              this.showSuspendedModal();
            }
          }
          this.$store.commit("setStatusInfo", response.data);
        })
        .catch((error) => {});
    },
    showWarningModal() {
      this.$modal.show("warningModal");
    },
    showSuspendedModal() {
      this.$modal.show("suspendedModal");
    },
    changeCountry(e) {
      console.log(e.target.value);
      this.$store.commit("setCountry", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      console.log(locale);
      localStorage.setItem(
        "countryProducts",
        JSON.stringify(countryProducts[e.target.value]),
      );

      this.$store.commit("setCountryProducts", countryProducts[e.target.value]);
    },
    changeLanguage(e) {
      //   console.log(e.target.value);
      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      //   console.log(locale);
      localStorage.setItem("locale", locale);
      this.$eventHub.$emit("remountCom");
    },
    checkViewOnly() {
      this.isViewOnly = this.$store.getters.getViewOnly;
    },
    signOutUser() {
      const answer = window.confirm(
        this.$t("text.cMasterLayout.confirmLogout"),
      );
      if (answer) {
        if (localStorage.getItem("locale")) {
          const locale = localStorage.getItem("locale");
          this.$store.commit("setBaseLocale", locale);
        }
        this.$store.commit("setModalShown", false);
        this.$store.commit("setStatusInfo", {});
        this.$store.commit("setBranchModalShown", false);
        this.$store.commit("setBranchStatusInfo", {});

        this.$store.dispatch("logout");
      }
    },
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
    getGroup() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/GroupManagement/MyGroups`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.group = response.data[0];

          // Logic for subscription plan feature
          let subPlanFeat;
          let isSubPlanFeat;
          subPlanFeat = response.data[0].planFeatures;
          isSubPlanFeat = localStorage.getItem("subPlanFeatures");
          if (!isSubPlanFeat) {
            localStorage.setItem(
              "subPlanFeatures",
              JSON.stringify(subPlanFeat),
            );
            this.comPlanFeatures = JSON.parse(
              localStorage.getItem("subPlanFeatures"),
            );
          }
          const PriceApproval = response.data[0].priceApproval;
          localStorage.setItem("PriceApproval", JSON.stringify(PriceApproval));

          // this.comPlanFeatures = response.data[0].planFeatures;
          // console.log(this.comPlanFeatures);
          // Logic for subscription plan feature ended

          this.$eventHub.$emit("group", response.data[0]);

          this.checkStatus();
          this.getGroupRating();
        })
        .catch((error) => {});
    },
    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ")
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ")
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ")
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ")
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ")
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ")
      );
    },
    toggleCollapsibleNavBar() {
      this.collapseNavbar = !this.collapseNavbar;
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));

      if (!this.collapseNavbar) {
        const allListTitles = Array.from(
          document.querySelectorAll(".sidenav_list_title"),
        );
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("list_open")) {
            el.classList.remove("list_open");
            el.classList.add("open");
          }
        });
      } else {
        if (
          document.querySelector(".sidebar").classList.contains("collapsed")
        ) {
          allListTitles.forEach((el) => {
            el.style.display = "none";
          });
        }

        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("open")) {
            el.classList.add("list_open");
            el.classList.remove("open");
          }
        });
      }
    },
    toggleSidenavText() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          const classList = Array.from(el.classList);
          if (classList.includes("open")) {
            el.classList.add("open");
            el.classList.remove("list_open");
          }
        });
      }
    },
    hideTitles() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );

      Array.from(document.querySelectorAll("li")).forEach((li) => {
        li.classList.remove("open");
      });

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
  },
};
</script>
